<div class="container mt-4">
    <button class="btn btn-primary mb-3" (click)="addCustomLayout()">Add Custom Layout</button>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Short Code</th>
                <th>Description</th>
                <th>Remarks</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let customLayout of customLayouts">
                <td>{{ customLayout.LayoutShortCode }}</td>
                <td>{{ customLayout.LayoutDescription }}</td>
                <td>{{ customLayout.LayoutRemarks }}</td>
                <td>
                    <button class="btn btn-secondary" (click)="editLayoutLines(customLayout)">Edit Lines</button>
                </td>
            </tr>
        </tbody>
    </table>
</div>